var y=Object.defineProperty;var A=(a,s,i)=>s in a?y(a,s,{enumerable:!0,configurable:!0,writable:!0,value:i}):a[s]=i;var v=(a,s,i)=>A(a,typeof s!="symbol"?s+"":s,i);import{s as I,i as k,x as d}from"./chunk-lit-element-D_hOyXEy.js";class b extends I{constructor(){super(),this.swatches=[],this.activeProductHandle="",this.scrollIndex=0,this.showArrows=!1,this.atEnd=!1,this.isInverted=document.body.classList.contains("inverted-template")}isDesktop(){return window.innerWidth>=768}render(){const s=this.swatches.slice(this.scrollIndex,this.scrollIndex+5),i=this.scrollIndex===0,c=this.swatches.length-(this.scrollIndex+5);return d`
      <div class="swatch-track-wrapper ${this.isInverted?"inverted":""}">
        <div class="swatch-track">
          ${s.map(t=>d`
              <div
                class="swatch"
                style="${t.colorCode&&t.colorUrl.includes("no-color")?`background-color: ${t.colorCode};`:`background-image: url('${t.colorUrl}'); background-size: cover;`}"
                data-image="${t.image}"
                data-url="${t.url}"
                data-sizes="${JSON.stringify(t.sizes)}"
                data-size-map="${JSON.stringify(t.sizeMap)}"
                data-product-id="${t.productId}"
                aria-label="${t.label}"
                aria-selected="${t.handle===this.activeProductHandle}"
                @mouseenter="${()=>this.isDesktop()&&this.updateProductCard(t.image,t.hoverImage,t.label,t.url,t.sizes,t.sizeMap,t.productId)}"
                @click="${()=>this.updateProductCard(t.image,t.hoverImage,t.label,t.url,t.sizes,t.sizeMap,t.productId)}"
              ></div>
            `)}     
        </div>

        ${!this.showArrows&&this.swatches.length>5?d`<span class="remaining-count" @click="${this.enableArrows}">+${c}</span>`:null}

        ${this.showArrows&&!this.atEnd?d`
              <button class="arrow" @click="${this.scrollRight}" aria-label="Next colors"><img src="${this.isInverted?"https://www.jamesperse.com/cdn/shop/t/601/assets/color-next-white.svg?v=155872343982211292901741628316":"https://www.jamesperse.com/cdn/shop/t/601/assets/color-next.svg?v=85480871274885356581741628316"}" data-uw-rm-alt-original="" role="presentation" alt="" data-uw-rm-alt="SVG"></button>
            `:null}

        ${this.showArrows&&this.atEnd&&!i?d`
              <button class="arrow" @click="${this.scrollLeft}" aria-label="Previous colors"><img src="${this.isInverted?"https://www.jamesperse.com/cdn/shop/t/601/assets/color-prev-white.svg?v=2838062297388824231741628317":"https://www.jamesperse.com/cdn/shop/t/601/assets/color-prev.svg?v=163364682755055692051741628317"}" data-uw-rm-alt-original="" role="presentation" alt="" data-uw-rm-alt="SVG"></button>
            `:null}
      </div>
    `}enableArrows(){this.showArrows=!0}scrollRight(){this.scrollIndex+5<this.swatches.length&&(this.scrollIndex+=1,this.scrollIndex+5>=this.swatches.length&&(this.atEnd=!0))}scrollLeft(){this.scrollIndex>0&&(this.scrollIndex-=1,this.scrollIndex==0&&(this.atEnd=!1))}updateProductCard(s,i,c,t,x,p,h){const e=this.closest("[product-url]"),o=e==null?void 0:e.querySelector(".product-card-image"),l=e==null?void 0:e.querySelector(".product-card-image-hover"),m=e==null?void 0:e.querySelector(".active-color-name"),n=e==null?void 0:e.querySelectorAll(".product-card-url"),g=e==null?void 0:e.querySelector(".product-card-sizes"),w=x.map(r=>{var u;return`<li class='mt-0 mb-[3px] mr-[5px] ml-[5px] ${r.available?"":"opacity-[.5]"}'>
        <form method="post" action="/cart/add" id="product_form_${h}" accept-charset="UTF-8" class="shopify-product-form px-[5px] max-h-[18px] flex hover:bg-[#f1f2f3] hover:group-[.inverted-template]/inverted:bg-[#fff3]" enctype="multipart/form-data" data-productid="${h}">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" class="input_variant" name="id" data-productid="${h}" value="${r.id}">
          <button name="add" aria-label="size ${r.size}" class="addtocart-js text-[12px] leading-[18px] font-bold" ${r.available?"":"disabled"}>     
            ${r.size} ${(u=p==null?void 0:p[0])!=null&&u[r.size]?"/"+p[0][r.size]:""}
          </button>
          <input type="hidden" name="product-id" value="${h}">
        </form>
      </li>`});o&&(this._originalImage||(this._originalImage={src:o.getAttribute("src"),srcset:o.getAttribute("srcset")}),o.setAttribute("src",s),o.setAttribute("srcset",`${s} 1x`)),l&&(this._originalImage||(this._originalImage={src:l.getAttribute("src"),srcset:l.getAttribute("srcset")}),l.setAttribute("src",i),l.setAttribute("srcset",`${i} 1x`)),m&&c&&(this._originalLabel=this._originalLabel||m.textContent,m.textContent=c),n!=null&&n.length&&(this._originalLinks=this._originalLinks||Array.from(n).map(r=>r.getAttribute("href")),n.forEach(r=>r.setAttribute("href",t))),g&&(g.innerHTML=w.join(""),this._sizesContainerListenerAdded||(g.addEventListener("submit",r=>{if(r.target.tagName==="FORM"){r.preventDefault();const u=r.target,$=new FormData(u);fetch("/cart/add.js",{method:"POST",body:$}).then(f=>f.json()).catch(f=>console.error("error adding to cart:",f))}}),this._sizesContainerListenerAdded=!0))}}v(b,"properties",{swatches:{type:Array},activeProductHandle:{type:String},scrollIndex:{type:Number},showArrows:{type:Boolean}}),v(b,"styles",k`
    .swatch-track-wrapper {
      position: relative;
      display: flex;
      align-items: center;
    }
    .swatch-track {
      display: flex;
      gap: 0.375rem;
      padding: 0.25rem 0;
      overflow: hidden;
      width: auto;
      max-width: 150px;
    }
    .swatch {
      flex: 0 0 auto;
      width: 16px;
      height: 16px;
      border: 1px solid white;
      cursor: pointer;
      transition: border 0.2s;
    }
    .swatch:hover,
    .swatch[aria-selected="true"] {
      border-color: black;
    }
    .arrow {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 14px;
      padding: 0 4px;
      line-height: 1;
      display: flex;
      align-items: center;
      margin-top: 1px;
    }
    .remaining-count {
      font-size: 12px;
      margin-left: 6px;
      cursor: pointer;
    }
    .swatch-track-wrapper.inverted,
    .swatch-track-wrapper.inverted .arrow  {
      color: #fff;
      background: transparent!important;
    }
  `);customElements.define("product-card-swatch",b);
